import { useEffect } from 'react';

// Initialize Google Analytics
const useGoogleAnalytics = () => {
  useEffect(() => {
    // Google Analytics measurement ID for ZS NEXATECH
    const GA_ID = 'G-B0SN8T76Q2';

    // Create script for Google Analytics
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', GA_ID, {
      page_path: window.location.pathname,
    });

    // Track page views
    const handleRouteChange = () => {
      gtag('event', 'page_view', {
        page_path: window.location.pathname,
      });
    };

    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);
};

export default useGoogleAnalytics;

// Function to track custom events
export const trackEvent = (eventName, eventData = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventData);
  }
};

// Function to track form submissions
export const trackFormSubmission = (formName) => {
  trackEvent('form_submission', {
    form_name: formName,
  });
};

// Function to track link clicks
export const trackLinkClick = (linkName) => {
  trackEvent('link_click', {
    link_name: linkName,
  });
};
